import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import { DateUtils, TimezoneUtils } from '@anyx/shared-utils';


dayjs.extend(relativeTime);

/**
 * Formats a Unix timestamp to a relative date string based on the user's current timezone and language.
 *
 * @param {number} timestamp - The Unix timestamp in second (10 digits) to format.
 * @returns {string} The formatted relative date string. If the timestamp is not provided, returns '-'.
 */
export function useFormatUnixTimeToRelativeDate(timestamp: number) {
  if (!timestamp) {
    return '-';
  }

  const timezone = TimezoneUtils.getCurrentTimezone();

  const currentDateInTZ = dayjs().tz(timezone);
  const inputDateInTZ = dayjs.unix(timestamp).tz(timezone);

  const differenceInHours = currentDateInTZ.diff(inputDateInTZ, 'hour');
  const isWithin21Hours = Math.abs(differenceInHours) <= 21;

  if (isWithin21Hours) {
    return inputDateInTZ.fromNow();
  }

  return inputDateInTZ.format(DateUtils.FORMATS.LLHHmm);
}
